export default __webpack_public_path__ + "static/falguni-sheth-957e542464899a09cd0d544534eac8bd.png";